import React from 'react';
import t from 'prop-types';

var EntradaTipoLeccion = function EntradaTipoLeccion(_ref) {
  var titulo = _ref.titulo,
      pagina = _ref.pagina,
      _onClick = _ref.onClick;
  return React.createElement('div', {
    className: 'leccionIndice',
    key: pagina + '-' + titulo,
    onClick: function onClick() {
      return _onClick(pagina);
    },
    dangerouslySetInnerHTML: {
      __html: titulo
    }
  });
};

EntradaTipoLeccion.propTypes = process.env.NODE_ENV !== "production" ? {
  titulo: t.string,
  pagina: t.number,
  onClick: t.func
} : {};
export default EntradaTipoLeccion;